import { AppStrings } from "./constants/AppStrings";
import type { UserKycStatus } from "../types/users";

export const USER_KYC_STATUS_VALUES = [
  "not_verified",
  "verified",
  "rejected",
  "reverification_required",
  "pending_review",
] as const;

export type KnownUserKycStatus = (typeof USER_KYC_STATUS_VALUES)[number];
export type KycStatusTone = "success" | "pending" | "error" | "neutral";

export type KycStatusPresentation = {
  label: string;
  tone: KycStatusTone;
};

export function getKycStatusPresentation(
  status: UserKycStatus | undefined,
): KycStatusPresentation {
  switch (status) {
    case "verified":
      return { label: AppStrings.VERIFIED, tone: "success" };
    case "rejected":
      return { label: AppStrings.REJECTED, tone: "error" };
    case "reverification_required":
      return { label: AppStrings.FAILED, tone: "error" };
    case "pending":
    case "pending_review":
      return { label: AppStrings.PENDING_REVIEW, tone: "pending" };
    case "not_verified":
      return { label: AppStrings.NOT_VERIFIED, tone: "neutral" };
    default:
      return { label: AppStrings.NOT_AVAILABLE, tone: "neutral" };
  }
}

export function getKycStatusFilterOptions() {
  return USER_KYC_STATUS_VALUES.map((value) => ({
    value,
    label: getKycStatusPresentation(value).label,
  }));
}
